module.exports = __webpack_public_path__ + "static/img/Frame 1710.cb587e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/Frame 1710.png
// module id = nhsd
// module chunks = 12